import React, { useState, useEffect } from 'react';
import { Users, CheckCircle, CreditCard, Award } from 'lucide-react';
import { API_URL } from '../../config';

export default function ReferralsView({ adminData }) {
  const [referrals, setReferrals] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReferrals();
  }, []);

  const fetchReferrals = async () => {
    try {
      const token = localStorage.getItem('snapshot_token');
      const res = await fetch(`${API_URL}/api/admin/referrals`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (!res.ok) throw new Error('Failed to fetch referrals');
      
      const data = await res.json();
      setReferrals(data);
    } catch (error) {
      console.error('Error fetching referrals:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center py-12">
        <div className="animate-spin w-12 h-12 border-4 border-[#10B981] border-t-transparent rounded-full mx-auto"></div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="max-w-7xl mx-auto">
        
        <h2 className="text-3xl font-bold mb-8">
          Referrals <span className="text-[#10B981]">Übersicht</span>
        </h2>

        {/* Summary */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-8">
          <div className="p-4 bg-black border-2 border-white/10 rounded-xl text-center">
            <p className="text-2xl font-bold text-white">{referrals?.summary.total_links || 0}</p>
            <p className="text-xs text-white/60">Gesamt Links</p>
          </div>
          <div className="p-4 bg-black border-2 border-[#10B981]/30 rounded-xl text-center">
            <p className="text-2xl font-bold text-[#10B981]">{referrals?.summary.active_links || 0}</p>
            <p className="text-xs text-white/60">Aktive Links</p>
          </div>
          <div className="p-4 bg-black border-2 border-white/10 rounded-xl text-center">
            <p className="text-2xl font-bold text-white">{referrals?.summary.total_invites || 0}</p>
            <p className="text-xs text-white/60">Einladungen</p>
          </div>
          <div className="p-4 bg-black border-2 border-white/10 rounded-xl text-center">
            <p className="text-2xl font-bold text-white">{referrals?.summary.total_registrations || 0}</p>
            <p className="text-xs text-white/60">Registrierungen</p>
          </div>
          <div className="p-4 bg-black border-2 border-white/10 rounded-xl text-center">
            <p className="text-2xl font-bold text-white">{referrals?.summary.total_purchases || 0}</p>
            <p className="text-xs text-white/60">Erste Käufe</p>
          </div>
          <div className="p-4 bg-black border-2 border-white/10 rounded-xl text-center">
            <p className="text-2xl font-bold text-[#10B981]">{referrals?.summary.total_earned_snaps || 0}</p>
            <p className="text-xs text-white/60">SNAPs verdient</p>
          </div>
        </div>

        {/* Details Table */}
        <div className="bg-black border-2 border-white/10 rounded-xl overflow-hidden">
          <table className="w-full">
            <thead className="bg-white/5 border-b border-white/10">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-bold text-white/70">User-ID</th>
                <th className="px-4 py-3 text-left text-xs font-bold text-white/70">Referral-Code</th>
                <th className="px-4 py-3 text-right text-xs font-bold text-white/70">Einladungen</th>
                <th className="px-4 py-3 text-right text-xs font-bold text-white/70">Registrierungen</th>
                <th className="px-4 py-3 text-right text-xs font-bold text-white/70">Käufe</th>
                <th className="px-4 py-3 text-right text-xs font-bold text-white/70">SNAPs</th>
                <th className="px-4 py-3 text-left text-xs font-bold text-white/70">Status</th>
              </tr>
            </thead>
            <tbody>
              {referrals?.stats.map((stat) => (
                <tr key={stat._id} className="border-b border-white/5 hover:bg-white/5">
                  <td className="px-4 py-3 font-mono text-xs text-white/70">
                    {stat.user_id.substring(0, 12)}...
                  </td>
                  <td className="px-4 py-3 font-mono text-[#10B981]">{stat.referral_code}</td>
                  <td className="px-4 py-3 text-right text-white">{stat.total_invites || 0}</td>
                  <td className="px-4 py-3 text-right text-white">{stat.successful_registrations || 0}</td>
                  <td className="px-4 py-3 text-right text-white">{stat.successful_purchases || 0}</td>
                  <td className="px-4 py-3 text-right font-bold text-[#10B981]">{stat.earned_snaps || 0}</td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-1 rounded text-xs font-bold ${
                      stat.is_active ? 'bg-[#10B981]/20 text-[#10B981]' : 'bg-white/10 text-white/50'
                    }`}>
                      {stat.is_active ? 'Aktiv' : 'Abgelaufen'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}
